import { useEffect, useRef } from 'react'

import { useLocation } from 'react-router'
import { useDebouncedCallback } from 'use-debounce'

// ///////////////////////
// MARK: TYPES
export interface IHelpersScrollToTopProps {}

// ///////////////////////
// MARK: EXPORTS
export const ScrollToTop: React.FC<IHelpersScrollToTopProps> = (props) => {
  const visitedRoutes = useRef(
    new Map<string, [number, number]>(
      JSON.parse(window.sessionStorage.getItem('scroll_restoration')!) as [
        string,
        [number, number],
      ][],
    ),
  )
  const { key } = useLocation()

  const saveToSession = useDebouncedCallback(() => {
    window.sessionStorage.setItem(
      'scroll_restoration',
      JSON.stringify([...visitedRoutes.current.entries()]),
    )
  }, 100)

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }
  }, [])

  // useEffect(() => {
  //   const values: [number, number] = visitedRoutes.current.get(key ?? '') ?? [0, 0]
  //   setTimeout(() => {
  //     window.scrollTo(...values)
  //   }, 1)
  // }, [key])

  useEffect(() => {
    const setScroll = () => {
      visitedRoutes.current.set(key ?? '', [window.scrollX, window.scrollY])

      saveToSession()
    }

    window.addEventListener('scroll', setScroll)
    return () => window.removeEventListener('scroll', setScroll)
  }, [key, saveToSession])

  return null
}
